import React from 'react';
import DateTimeField from '../../../utils/DateTimeField/DateTimeField';
import moment from 'moment';

export function DatePicker({date, onChange, orientation}) {
    const format = "MM/DD/YYYY";
    const dateTime = moment(date).zone('+0300').format('x');
    return (
        <DateTimeField
            mode="date"
            viewMode="days"
            inputFormat={format}
            dateTime={dateTime}
            orientation={orientation}
            inputProps={{
                name: "ordersFilterEnd",
                className: "form-control filter_input"
            }}
            onChange={event => onChange(new Date(+event))} />
    );
}



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/ordersFilter/DatePicker.js